class InterviewFilter {
  constructor(rootSelector) {
    this.root = document.querySelector(rootSelector);

    if (!this.root) {
      return;
    }

    this.groups = this.root.querySelectorAll('[data-interview-filter-group]');
    this.groups.forEach((group) => {
      this.initGroup(group);
    });
  }

  initGroup(group) {
    const allButton = group.querySelector('[data-filter-all]');
    const items = Array.from(group.querySelectorAll('[data-filter-item]'));

    if (!allButton || !items.length) {
      return;
    }

    const syncAllButton = () => {
      const allChecked = items.every((item) => item.checked);
      allButton.classList.toggle('is-current', allChecked);
    };

    const setAllChecked = (checked) => {
      items.forEach((item) => {
        item.checked = checked;
        const label = item.closest('.p-interview__filter-tag');
        if (label) {
          label.classList.toggle('is-current', checked);
        }
      });
      allButton.classList.toggle('is-current', checked);
    };

    allButton.addEventListener('click', () => {
      const allChecked = items.every((item) => item.checked);
      setAllChecked(!allChecked);
    });

    items.forEach((item) => {
      item.addEventListener('change', () => {
        const label = item.closest('.p-interview__filter-tag');
        if (label) {
          label.classList.toggle('is-current', item.checked);
        }
        syncAllButton();
      });
    });

    syncAllButton();
  }
}
